import { useCallback, useState } from 'react';
import {
  GlobalSearchDialog,
  GlobalSearchMobileButton,
  GlobalSearchTrigger,
  useGlobalSearchHotkey,
} from '@/features/search';
import { ContextualHelp } from './header/ContextualHelp';
import { HeaderCreateMenu } from './header/HeaderCreateMenu';
import { HeaderNextUp } from './header/HeaderNextUp';
import { WorkingDayChip } from './header/WorkingDayChip';
import { HEADER_TOOLBAR_CLUSTER } from './header/header-chrome';

/**
 * Ops-focused utility header — day/floor pulse, next up, create, tips.
 * Clinic switcher and account menu remain in the sidebar.
 */
export function Header(): JSX.Element {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const openSearch = useCallback(() => setIsSearchOpen(true), []);
  const onSearchOpenChange = useCallback((open: boolean) => setIsSearchOpen(open), []);

  useGlobalSearchHotkey(isSearchOpen, onSearchOpenChange);

  return (
    <header className="app-header relative z-30 flex h-16 shrink-0 items-center gap-2 border-b hairline px-4 sm:gap-3 lg:px-6">
      <div className="pointer-events-none absolute inset-0 app-header-wash" aria-hidden />
      <div className="relative flex min-w-0 flex-1 items-center gap-2.5">
        <GlobalSearchTrigger onOpen={openSearch} />
        <GlobalSearchMobileButton onOpen={openSearch} />
      </div>

      <div className={HEADER_TOOLBAR_CLUSTER}>
        <WorkingDayChip />
        <HeaderNextUp />
        <div className="mx-0.5 hidden h-6 w-px bg-surface-200/70 sm:block" aria-hidden />
        <HeaderCreateMenu />
        <ContextualHelp />
      </div>

      <GlobalSearchDialog open={isSearchOpen} onOpenChange={onSearchOpenChange} />
    </header>
  );
}
